import IconHome from '@/components/icons/icon-home';
import IconDataPanel from '@/components/icons/icon-data-panel';
import IconSystem from '@/components/icons/icon-system';
import IconTodo from '@/components/icons/icon-todo';
import IconFlowOperate from '@/components/icons/icon-flow-operate';
import IconUserOperate from '@/components/icons/icon-user-operate';
import IconAdvertise from '@/components/icons/icon-advertise';
import IconTools from '@/components/icons/icon-tools';
import PageTitle from '@/pages/all-about-me/activity-message-center/components/page-title';
import { MenuPopGuide } from '@/pages/all-about-me/components/signed-activity/components/pop-guide';
import env from '@/env';

function menuLog(name1, name2) {
  const param = {};
  if (name1) param.menuname1 = name1;
  if (name2) param.menuname2 = name2;
  window.log('yx_center', 'menubutton', JSON.stringify(param));
}

// 一级路由的path是用来计算的，是一级路由的唯一key
// 二级路由的path必须是全路径，因为菜单层级可能会变化层级，所以一级、二级菜单的路由关系要解绑。
// 必须配置menuId作为唯一的key,menuCode为后端下发的AUth_key

export default [
  {
    menuCode: '002',
    menuId: 25,
    path: '/',
    title: '工作台',
    Icon: IconHome,
    customLog() {
      menuLog('工作台');
    },
    getlog() {
      return 'yx_center_1629184833805|37';
    },
  },
  {
    menuCode: '003',
    menuId: 57,
    path: '/all-about-me',
    title: '待办事项',
    Icon: IconTodo,
    customLog() {
      menuLog('待办事项');
    },
    getlog() {
      return 'yx_center_1629184833805|38';
    },
    menus: [
      {
        title: <MenuPopGuide>活动报名</MenuPopGuide>,
        path: '/all-about-me/signed-activity',
        customLog() {
          menuLog('活动管理', '活动报名');
        },
        getlog() {
          return 'yx_center_1721705231097|1';
        },
        getLink() {
          return '/all-about-me/signed-activity/reportable-activities';
        },
      },
      {
        title: '资源分配',
        path: '/all-about-me/res-divider',
        customLog() {
          menuLog('活动管理', '资源分配');
        },
        getlog() {
          return 'yx_center_1721705231097|1';
        },
        getLink() {
          return '/all-about-me/res-divider/room/activityReceipt';
        },
      },
      {
        menuCode: '003-2',
        menuId: 58,
        path: '/all-about-me/audit-material',
        title: '待审核管理',
        customLog() {
          menuLog('待办事项', '待审核管理');
        },
      },
      {
        menuCode: '003-3',
        menuId: 59,
        path: '/all-about-me/signed-material',
        title: '已报名素材',
        customLog() {
          menuLog('待办事项', '已报名素材');
        },
        getlog() {
          return 'yx_center_1629184833805|49';
        },
      },
      {
        menuCode: '003-1',
        menuId: 109,
        path: '/all-about-me/activity-message-center',
        title: <PageTitle />,
        customLog() {
          menuLog('待办事项', '活动动态');
        },
      },
    ],
  },
  {
    title: '活动管理',
    path: '/flow-operate',
    Icon: IconFlowOperate,
    menuCode: '005',
    menuId: 95,
    customLog() {
      menuLog('活动管理');
    },
    menus: [
      {
        menuCode: '005-1',
        menuId: 11,
        path: '/activity-manage',
        title: '主题活动',
        businessId: 10003,
        customLog() {
          menuLog('活动管理', '主题活动');
        },
        getlog() {
          return 'yx_center_1629184833805|39';
        },
        getLink() {
          return '/activity-manage/list';
        },
      },
      {
        title: '会场活动',
        path: '/activity-manage/myCreate',
        menuCode: '005-2',
        menuId: 54,
        customLog() {
          menuLog('活动管理', '会场活动');
        },
        getlog() {
          return 'yx_center_1629184833805|50';
        },
        getLink() {
          return '/activity-manage/myCreate/room';
        },
      },
      {
        title: '综合促销',
        path: '/activity-manage/myCreate/zongcuActivity',
        menuCode: '005-3',
        menuId: 55,
        customLog() {
          menuLog('活动管理', '综合促销');
        },
        getlog() {
          return 'yx_center_1629184833805|51';
        },
      },
      {
        menuCode: '005-4',
        menuId: 65,
        path: '/platform-marketing',
        title: '平台营销',
        customLog() {
          menuLog('活动管理', '平台营销');
        },
      },
      {
        menuCode: '005-5',
        menuId: 35,
        path: '/channel-service',
        title: '行业频道',
        customLog() {
          menuLog('活动管理', '行业频道');
        },
        getlog() {
          return 'yx_center_1629184833805|41';
        },
      },

      {
        title: '搭售运营',
        menuCode: '005-13',
        menuId: 114,
        path: '/in-operation',
        customLog() {
          menuLog('活动管理', '搭售运营');
        },
      },
      {
        title: '情报中心',
        path: '/information-center',
        menuCode: '005-14',
        menuId: 116,
        customLog() {
          menuLog('活动管理', '情报中心');
        },
        getlog() {
          return 'yx_intelligence_1716864670814|1';
        },
      },
    ],
  },
  {
    title: '流量运营',
    path: '/flow-operate1',
    menuId: 120,
    menuCode: '011',
    Icon: IconAdvertise,
    customLog() {
      menuLog('流量运营');
    },
    menus: [
      // {
      //   title: '盘货运营',
      //   path: '/operations-workbench',
      //   menuId: 119,
      //   menuCode: '005-15',
      //   customLog() {
      //     menuLog('流量运营中心', '流量运营');
      //   },
      // },
      {
        title: '黄流运营',
        path: '/cargo-gold-operate',
        menuCode: 'huangliuyunying',
        menuId: 117,
        customLog() {
          menuLog('流量运营', '黄流运营');
        },
        getlog() {
          return 'yx_center_1721705231097|3';
        },
        getLink() {
          return '/cargo-gold-operate/#/operation/jdapp/gold';
        },
      },
      {
        title: '搜推运营',
        path: '/search-operate',
        menuCode: '005-10',
        menuId: 99,
        customLog() {
          menuLog('流量运营', '搜推运营');
        },
      },
      {
        title: '推荐运营',
        path: '/recommend-operate',
        menuCode: '005-8',
        menuId: 98,
        customLog() {
          menuLog('流量运营', '推荐运营');
        },
      },
      {
        title: '广告运营',
        path: 'http://admin.ads.jd.com/manage/#/home',
        target: '_blank',
        menuId: 112,
        menuCode: '010',
        customLog() {
          menuLog('流量运营', '广告运营');
        },
      },
    ],
  },
  {
    title: '用户运营',
    path: '/user-operate1',
    Icon: IconUserOperate,
    menuCode: '006',
    menuId: 100,
    customLog() {
      menuLog('用户运营');
    },
    menus: [
      {
        menuCode: '006-1',
        menuId: 110,
        title: '平台邀约',
        path: '/user-operate',
        customLog() {
          menuLog('用户运营', '平台邀约');
        },
      },
      {
        menuCode: '006-2',
        menuId: 111,
        title: '用户增长',
        path: '/category-diy',
        customLog() {
          menuLog('用户运营', '用户增长');
        },
      },
      {
        menuCode: '006-3',
        menuId: 115,
        title: '用户触达',
        path: '/reach-operations',
        customLog() {
          menuLog('用户运营', '用户触达');
        },
      },
      {
        title: '桃花岛',
        menuCode: '006-4',
        path: '/peach-blossom',
        customLog() {
          menuLog('用户运营', '桃花岛');
        },
      },
    ],
  },
  {
    title: '营销工具',
    Icon: IconTools,
    path: '/yxtool',
    menuCode: '007',
    menuId: 101,
    customLog() {
      menuLog('营销工具');
    },
    menus: [
      {
        path: '/yxtools',
        title: '全部工具',
        menuCode: '007-2',
        customLog() {
          menuLog('营销工具', '全部工具');
        },
      },
      {
        title: '潘多拉',
        path: '/pandora',
        target: '_blank',
        menuCode: '007-1',
        menuId: 102,
        customLog() {
          menuLog('营销工具', '潘多拉');
        },
      },
    ],
  },
  {
    menuCode: '008',
    menuId: 4,
    path: '/data-panel',
    title: '数据分析',
    Icon: IconDataPanel,
    customLog() {
      menuLog('数据分析');
    },
    getlog() {
      return 'yx_center_1629184833805|44';
    },
    menus: [
      {
        menuCode: '004-2',
        menuId: 92,
        path: '/product-manager',
        title: '商品监控',
        customLog() {
          menuLog('货品运营', '商品监控');
        },
      },
      {
        menuCode: '004-3',
        menuId: 93,
        path: '/product-manager/big-boss-panel',
        title: '场域监控',
        customLog() {
          menuLog('货品运营', '场域监控');
        },
      },
    ],
  },

  {
    menuCode: '009',
    menuId: 5,
    path: '/system',
    title: '系统设置',
    Icon: IconSystem,
    customLog() {
      menuLog('系统设置');
    },
    getlog() {
      return 'yx_center_1629184833805|46';
    },
    menus: [
      {
        path: '/system/authSetting',
        title: '权限管理',
        menuCode: '009-1',
        menuId: 999,
        getlog() {
          return 'yx_center_1629184833805|71';
        },
        customLog() {
          menuLog('系统设置', '权限管理');
        },
      },
      {
        path: '/system/powermanage',
        title: '业务角色',
        menuCode: '009-2',
        menuId: 6,
        customLog() {
          menuLog('系统设置', '业务角色');
        },
        getlog() {
          return 'yx_center_1629184833805|71';
        },
      },
      {
        menuCode: '009-3',
        menuId: 90,
        path: '/system/shield-policy',
        title: '屏蔽策略',
        customLog() {
          menuLog('系统设置', '屏蔽策略');
        },
      },
      {
        path: '/system/c-shop-manager',
        title: 'C店负责人',
        customLog() {
          menuLog('系统设置', 'C店负责人');
        },
        menuCode: '009-4',
        menuId: 84,
      },
      {
        path: '/system/channel-manage',
        title: '频道管理',
        customLog() {
          menuLog('系统设置', '频道管理');
        },
        menuCode: '009-5',
        menuId: 63,
      },
      {
        menuCode: '009-6',
        menuId: 7,
        path: '/system/examinemanage',
        title: '流程配置',
        customLog() {
          menuLog('系统设置', '流程配置');
        },
        getlog() {
          return 'yx_center_1629184833805|72';
        },
      },
      {
        menuCode: '009-7',
        menuId: 45,
        path: '/system/resourcestatemanage',
        title: '资源位管理',
        customLog() {
          menuLog('系统设置', '资源位管理');
        },
        getlog() {
          return 'yx_center_1629184833805|73';
        },
      },
      {
        menuCode: '009-8',
        menuId: 33,
        path: '/system/applicationmanage',
        title: '运营位配置',
        customLog() {
          menuLog('系统设置', '运营位配置');
        },
        getlog() {
          return 'yx_center_1629184833805|74';
        },
      },
      {
        menuCode: '009-9',
        menuId: 62,
        path: '/system/whitelist',
        title: '白名单管理',
        customLog() {
          menuLog('系统设置', '白名单管理');
        },
      },
      {
        ignoreInRouter: true,
        menuCode: '009-10',
        menuId: 28,
        path: '/system/help',
        title: '帮助中心',
        customLog() {
          menuLog('系统设置', '帮助中心');
        },
        getlog() {
          return 'yx_center_1629184833805|75';
        },
      },
      {
        ignoreInRouter: true,
        menuCode: '009-11',
        menuId: 31,
        path: '/admin/announce',
        title: '公告管理',
        customLog() {
          menuLog('系统设置', '公告管理');
        },
        getlog() {
          return 'yx_center_1629184833805|76';
        },
        target: '_blank',
      },
      {
        menuCode: '009-12',
        menuId: 82,
        path: '/system/notify',
        title: '重要通知',
        customLog() {
          menuLog('系统设置', '重要通知');
        },
      },
      {
        title: '类目管理',
        menuCode: '009-13',
        menuId: 85,
        path: '/system/flowcate',
        customLog() {
          menuLog('系统设置', '类目管理');
        },
      },
      {
        title: '新品运营',
        path: '/system/newprodconf',
        menuCode: '009-14',
        menuId: 86,
      },
      {
        title: '排行榜运营',
        path: '/system/rankadmin',
        menuCode: '009-15',
        menuId: 113,
      },
      {
        title: '流量运营',
        menuId: 118,
        menuCode: '009-16',
        path: '/system/flow-setting',
      },
      {
        title: '代报名管理',
        menuCode: 'dbmgl',
        path: '/system/substitute-registration',
        getLink() {
          return `/system/substitute-registration?pageId=${env.MC_LOWCODE_PAGE.substituteRegistration}`;
        },
      },
    ],
  },
];
